import { useState, useEffect } from 'react';

/**
 * Hook que gerencia um state com uma versão "atrasada" (debounced) dele.
 *
 * @param initialValue O valor inicial do state.
 * @param delay O tempo de atraso em milissegundos.
 * @returns Um objeto contendo:
 * - value: O valor imediato (para inputs).
 * - setValue: A função para atualizar o valor.
 * - debouncedValue: O valor após o delay (para API).
 */
function useDebouncedState<T>(initialValue: T, delay: number) {
  const [value, setValue] = useState(initialValue);
  
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); 

  return {
    value,
    setValue,
    debouncedValue
  };
}

export default useDebouncedState;